import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanoContasEmpresaInserirComponent } from './plano-contas-empresa-inserir.component';

const routes: Routes = [
  {path: '', component: PlanoContasEmpresaInserirComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanoContasEmpresaInserirRoutingModule { }
